import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const WeeklyProgressChart = ({ data }) => {
  if (!data || !data.distribution) {
    return <div>No data available</div>;
  }

  const distribution = data.distribution;
  
  // Create labels and values arrays
  const labels = [];
  const values = [];
  
  // Add week entries
  for (let i = 1; i <= 10; i++) {
    const weekKey = `Week ${i}`;
    labels.push(weekKey);
    values.push(distribution[weekKey] || 0);
  }
  
  // Add "Not Started" and "Completed" at the end
  labels.push('Not Started', 'Completed');
  values.push(distribution['Not Started'] || 0, distribution['Completed'] || 0);

  const chartData = {
    labels: labels,
    datasets: [
      {
        label: 'Students',
        data: values,
        backgroundColor: labels.map((label, index) => {
          if (label === 'Not Started') return '#9ca3af';
          if (label === 'Completed') return '#10b981';
          return '#3b82f6';
        }),
        borderRadius: 6,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: (context) => `${context.parsed.y} students`,
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
        ticks: {
          precision: 0,
        },
        grid: {
          display: true,
          drawBorder: false,
        },
      },
      x: {
        grid: {
          display: false,
        },
        ticks: {
          font: {
            size: 11,
          },
        },
      },
    },
  };

  return (
    <div style={{ padding: '20px' }}>
      <h3 style={{ fontSize: '18px', fontWeight: 600, marginBottom: '8px', color: '#111827' }}>
        Weekly Progress Tracking
      </h3>
      <div style={{ fontSize: '13px', color: '#6b7280', marginBottom: '12px' }}>
        {data.course_status}
      </div>
      <div style={{ 
        fontSize: '12px', 
        color: '#6b7280', 
        marginBottom: '20px',
        padding: '12px',
        backgroundColor: '#f9fafb',
        borderRadius: '6px',
      }}>
        <div><strong>Total Tracked:</strong> {data.total_tracked} students</div>
        <div><strong>Current Week:</strong> Week {data.current_week_number}</div>
        <div><strong>Course Started:</strong> {data.course_start_date}</div>
      </div>
      <div style={{ height: '320px' }}>
        <Bar data={chartData} options={options} />
      </div>
    </div>
  );
};

export default WeeklyProgressChart;
